// extracted by mini-css-extract-plugin
module.exports = {"productItem":"Products_productItem__J_EFI"};